// src/pages/Error.js
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getErrorData, logError } from '../utils/errorUtils';
import '../styles/Error.css';

const Error = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // エラー情報をログ出力（errorDataとerrorDetailの両方）
  useEffect(() => { logError(searchParams); }, [])
  
  // クエリパラメータから画面表示用のエラーデータを取得
  const errorData = getErrorData(searchParams);
  
  /**
   * ログイン画面へ遷移
   */
  const handleGoToLogin = () => {
    navigate('/solicitor/login', { replace: true });
  };
  
  return (
    <div className="asfinder-error-container">
      <div className="error-content">
        <div className="error-icon-container">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="#ef4444">
            <path d="M12 2L1 21h22L12 2zm0 3.5L19.5 19h-15L12 5.5zM11 16v2h2v-2h-2zm0-6v4h2V10h-2z"/>
          </svg>
        </div>
        
        <h1 className="error-title">{errorData.title || '申し訳ございません'}</h1>
        <p className="error-message">{errorData.message}</p>
        
        {errorData.errorId && (
          <div className="error-id">
            <strong>エラーID:</strong> {errorData.errorId}
          </div>
        )}
        
        <button className="error-button" onClick={handleGoToLogin}>
          ログイン画面に戻る
        </button>
      </div>
    </div>
  );
};

export default Error;
